import { Circle, CircleCheckBig } from "lucide-react";
import { useMemo } from "react";
import { Button } from "../ui";
import useUiThemeState from "~/stores/ui/theme";
import { useTranslation } from "react-i18next";
import type { Theme } from "~/types/ui";
import { useResolvedMode } from "~/hooks/resolved-mode-hook";

export function ThemePicker() {
  const { t } = useTranslation();
  const themeState = useUiThemeState();
  const mode = useResolvedMode();

  const colors = useMemo(
    () =>
      [
        "zinc",
        "rose",
        "blue",
        "green",
        "orange",
        "red",
        "yellow",
        "violet",
      ] as Theme[],
    [],
  );

  return (
    <div className="mt-2">
      <h3 className="mb-2 font-medium">{t("common.selectThemeTitle")}</h3>
      <div className="grid xs:grid-cols-2 md:grid-cols-4 gap-4">
        {colors.map((color) => (
          <Button
            data-theme={`${color}-${mode}`}
            key={color}
            onClick={() => themeState.setTheme(color)}
            className="bg-background text-foreground hover:bg-muted"
          >
            {themeState.theme === color ? (
              <CircleCheckBig className="text-primary" />
            ) : (
              <Circle className="text-primary" />
            )}{" "}
            {color}{" "}
          </Button>
        ))}
      </div>
    </div>
  );
}
